import kebabCase from 'lodash/kebabCase'

const components = []
const files = require.context('.', true, /\Index.vue$/)

files.keys().forEach(fileName => {
  const path = fileName.replace(/\.\/|\/Index.vue/g, '')
  components[kebabCase(path)] = () => import(`./${path}/Index.vue`)
})

export default components
